<template>
  <div class="self-container">
    <div class="title-box">
      <div class="title-left">
        <div class="sign"></div>
        <span>{{ title || "道面数据" }}</span>
      </div>
      <div class="title-right"></div>
    </div>
    <div class="head-box">
      <div class="func-cell" @click="showPicker = true">
        <span>{{ columnsText[selectIndex] }}</span
        ><i class="my-right" />
      </div>
    </div>
    <div class="body-box">
      <div class="list-head">
        <span>最新资料时次：{{ datetimeValue }}(UTC)</span>
      </div>
      <div class="list-body">
        <van-row
            v-for="(item, i) in list"
            :key="i"
            :class="{
            'sf-row': true,
            'cell-bg-color': i % 2 < 1
          }"
        >
          <van-col span="12" class="sf-col-key">
            {{item.label}}
          </van-col>
          <van-col span="12" class="sf-col-val">
            {{item.value}}
          </van-col>
        </van-row>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
          show-toolbar
          :columns="columnsText"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          item-height="40"
          visible-item-count="3"
      />
    </van-popup>
    <van-overlay :show="pageLoading" @click="show = false">
      <van-loading type="spinner" />
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "pavement",
  data() {
    return {
      pageLoading:false,
      title: "",
      value: "ZWYT",
      datetimeValue: "",
      showPicker: false,
      columnsText: [
        "ZWYT 于田机场",
        "ZWZS 昭苏机场",
        "ZWAT 阿勒泰机场",
        "ZWCM 且末机场",
        "ZWFY 富蕴机场",
        "ZWHM 哈密机场",
        "ZWKC 库车机场",
        "ZWKL 库尔勒机场",
        "ZWKM 克拉玛依机场",
        "ZWKN 喀纳斯机场",
        "ZWNL 那拉提机场",
        "ZWRQ 若羌机场",
        "ZWSC 莎车机场",
        "ZWSH 喀什机场",
        "ZWTC 塔城机场",
        "ZWTN 和田机场",
        "ZWYN 伊宁机场",
        "ZWTL 吐鲁番机场",
        "ZWBL 博乐机场",
        "ZWTS 图木舒克机场"
        "ZWAL 阿拉尔机场"
        "ZWTK 塔什库尔干机场"
        "ZWHJ 巴音布鲁克机场"
        "ZWQT 奇台江布拉克机场"
      ],
      selectIndex: 0,
      // 闲置
      columns: [
        "ZWYT",
        "ZWZS",
        "ZWAT",
        "ZWCM",
        "ZWFY",
        "ZWHM",
        "ZWKC",
        "ZWKL",
        "ZWKM",
        "ZWKN",
        "ZWNL",
        "ZWRQ",
        "ZWSC",
        "ZWSH",
        "ZWTC",
        "ZWTN",
        "ZWYN",
        "ZWTL",
        "ZWBL",
        "ZWTS"
        "ZWAL"
        "ZWTK"
        "ZWHJ"
        "ZWQT"
      ],
      interID: '',
      list: [
        { key: "fourCode", label: "机场四字代码", value:'' },
        { key: "friction", label: "摩擦系数", value:'' },
        { key: "ftCaCl", label: "氯化钙冰点温度", value:'' },
        { key: "ftMgCl", label: "氯化镁冰点温度", value:'' },
        { key: "ftNaCl", label: "氯化钠冰点温度", value:'' },
        { key: "height", label: "水膜厚度", value:'' },
        { key: "icePer", label: "含冰率", value:'' },
        { key: "issueTime", label: "发布时间", value:'' },
        { key: "rcond", label: "道面状态", value:'' },
        { key: "scCaCl", label: "氯化钙浓度", value:'' },
        { key: "scMgCl", label: "氯化镁浓度", value:'' },
        { key: "scNaCl", label: "氯化钠浓度", value:'' },
        { key: "stationCode", label: "站点编号", value:'' },
        { key: "stemp", label: "表面温度", value:'' }
      ]
    };
  },
  destroyed() {
    if(this.interID !== ''){
      clearInterval(this.interID)
      console.log(`已清除[${this.interID}]定时器!`);
    }
  },
  methods: {
    // 选择器确认
    onConfirm(value, index) {
      this.selectIndex = index;
      this.value = this.columns[index];
      this.showPicker = false;
      this.getData();
    },
    // 定时查询 30s
    setInterFnc() {
      let that = this;
      try {
        if(that.interID === ''){
          let _interID = setInterval(function() {
            console.log("定时器执行!");
            that.getData();
          }, 30000);
          that.interID = _interID
          console.log(`已设置[${this.interID}]定时器!`);
        }
      } catch (e) {
        console.log("设置定时器失败，error:", e);
      }
    },
    // 查询数据处理
    realData(res){
      const that = this
      const { Data = [], ErrorMessage = '' } = res
      console.log('ErrorMessage', ErrorMessage)
      const [ info = {} ] = Data
      that.datetimeValue = info?.issueTime
      that.list.forEach((item, index)=>{
        const {key} = item
        that.list[index].value = info[key]||''
      })
    },
    // 获取道面数据
    getData() {
      const that = this
      let param = {
        user: that.$store.state.api_user,
        password: that.$store.state.api_password,
        version: "3",
        funversion: "1",
        funname:"project/aviationsystem/forecastdata/GetAviationRunwayInfoByAirportCodes",
        airportCodes:that.value
      };
      let _stringify = this.$qstring.stringify(param)
      that.pageLoading = true
      that.$http
          .get("/Services?" + _stringify)
          .then(r => {
            that.pageLoading = false
            console.log("道面源数据：", r);
            that.realData(r["data"]);
          })
          .catch(e => {
            that.pageLoading = false
            console.log("获取道面数据异常:", e);
          });
    }
  },
  created() {
    this.getData();
    this.setInterFnc();
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.self-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  margin: 0 auto;
  .title-box {
    display: flex;
    flex-direction: row;
    height: 8%;
    //height: px2rem(58);
    width: 95%;
    .title-left {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 32.5%;
      .sign {
        width: 3px;
        height: px2rem(16);
        background-image: linear-gradient(180deg, #fe5936 0%, #fca656 100%);
      }
      span {
        font-family: PingFangSC-Semibold;
        font-size: px2rem(18);
        color: #ffffff;
        margin-left: px2rem(4);
      }
    }
    .title-right {
      height: 100%;
      width: 67.5%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
    /*border: 1px solid violet;*/
  }
  .head-box {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    //height: px2rem(45);
    height: 8%;
    width: 95%;
    .func-cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: px2rem(44);
      width: 100%;
      background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
      box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.24),
      inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
      border-radius: px2rem(12);
      span {
        font-size: px2rem(16);
        color: #a0a2a4;
        margin-left: px2rem(17);
      }
      .my-right {
        border: solid rgb(151, 151, 151);
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        margin-right: px2rem(19);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
    /*border: 1px solid greenyellow;*/
  }
  .body-box {
    height: 82%;
    width: 95%;
    //margin-top: px2rem(12);
    .list-head {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 8%;
      span {
        font-size: 14px;
        color: #a9abad;
      }
    }
    .list-body {
      height: 92%;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      .sf-row {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: 10%;
        width: 100%;
        background-color: rgba(43, 62, 74, 0);
        flex-shrink: 0;
        font-size: px2rem(14);
      }
      .cell-bg-color {
        background-image: linear-gradient(
                180deg,
                rgb(33, 36, 40),
                rgb(33, 36, 40)
        );
      }
      .sf-col-key {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: #ffffff;
      }
      .sf-col-val {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: #d8d8d8;
      }
    }
  }
}
</style>
